import React from 'react';

const ColonFix = ({string}) => {

    const addColons = (theParts) => {
        let result = null;
        if (theParts.length > 0) {
            result = theParts.map((substring, index, array) => (
                <span key={`key-${substring.toLowerCase()}`}>
                    {index > 0 && (
                        <span className="hudl-colon-fix">:</span>
                    )}
                    <span>{substring}</span>
                </span>
            ));
        }
        if (theParts.length === 0) {
            result = string;
        }

        return result;
    };

    return (
        <>
            {addColons(string.split(':'))}
        </>
    );
};

export default ColonFix;
